import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import FutureOrderBook from "./FutureORderBook";
import { FutureDataContent } from ".";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { useTradingColors } from "../Spot/tradingColorConfig";

const FutureLeftTable = () => {
  const {
    setCurrencycode,
    setBasecurrency,
    setAssetPair,
    assetpair,
    setAssetPairName,
    setDerivativeAssets,
    newFiatArray,
  } = useContext(FutureDataContent);
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const { pairButtonColor, upColor, downColor } = useTradingColors();
  const [show, setShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(assetpair || "");
  const [currency, setCurrency] = useState("BTC");
  const [filterCurrency, setFilterCurrency] = useState([]);
  const [dropdownFiatList, setDropdownFiatList] = useState([]);
  const [assetetpair, setAssetetpair] = useState([]);
  const [assetetpairback, setAssetetpairback] = useState([]);
  const [assetetpairbackOrigin, setAssetetpairbackOriginal] = useState([]);
  const [roccolor, setRoccolor] = useState(false);
  const [ltpcolor, setLtpcolor] = useState(null);
  const [sort, setSort] = useState(false);
  const [showFiat, setShowFiat] = useState(false);
  const [fiatSelected, setFiatSelected] = useState("FIAT");
  const [filteredAssetPairs, setFilteredAssetPairs] = useState([]);
  const [header, setHeader] = useState([]);

  const [amountPrecision, setAmountPrecision] = useState(0);
  const [pricePrecision, setPricePrecision] = useState(0);
  const [assetCode, setAssetCode] = useState("");
  const [currencyId, setCurrencyId] = useState("");

  const handleClose = () => setShow(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  // useEffect(() => {
  //   const storedTradeP = localStorage.getItem("tradep");
  //   if (storedTradeP) {
  //     setTradep(parseInt(storedTradeP));
  //   }
  // }, []);

  useEffect(() => {
    if (assetpair) {
      setSelected(assetpair);
    }
  }, [assetpair]);

  useEffect(() => {
    setSelected(assetpair);
    setCurrencycode(
      localStorage.getItem("O_buying_crypto_asset")?.toUpperCase()
    );
    setBasecurrency(
      localStorage.getItem("O_selling_crypto_asset")?.toUpperCase()
    );
    getNewCurrency("USDT");
  }, []);

  const getNewCurrency = async (currency = "ALL") => {
    setCurrency(currency);
    try {
      const response = await axios.get(
        `https://accounts.paybito.com/CacheService/api/getData?Name=DerivativeAssets`
      );

      const data = JSON.parse(response.data.value);
      localStorage.setItem("derivative_assets", response.data.value);
      setDerivativeAssets(data.Values);

      if (data.Header.includes("USD")) {
        setHeader(data.Header);
      } else {
        const headers = data.Header;
        const index = headers.indexOf("USD");
        if (index > -1) {
          // only splice array when item is found
          headers.splice(index, 1); // 2nd parameter means remove one item only
        }
        setHeader(headers);
      }

      const assets = data.Values;
      const basecur = assets.find(
        (x) => x.baseCurrency === "USD" && x.currencyCode === "BTC"
      );

      if (basecur) {
        localStorage.setItem("amountprc", basecur.amountPrecision);
        localStorage.setItem("priceprc", basecur.pricePrecision);
        localStorage.setItem("assetCode", basecur.assetCode);
      }

      const basrcurrency = currency; // Replace with appropriate value
      const newAssetetpair = [];
      assets.forEach((asset) => {
        let isRocPositive = asset.roc > 0 ? true : false;
        let ltpColor =
          asset.action === "buy"
            ? true
            : asset.action === "sell"
            ? false
            : null;

        if (basrcurrency === asset.baseCurrency) {
          newAssetetpair.push({
            currencycode: asset.currencyCode,
            basecurrency: asset.baseCurrency,
            lastTrade1: asset.ltpValue,
            lastTrade2: asset.ltpConvValue,
            lPriceColor: ltpColor,
            roc: asset.roc,
            volume: asset.volume,
            rocColor: asset.roc > 0,
            amountPrecision: asset.amountPrecision,
            pricePrecision: asset.pricePrecision,
            assetCode: asset.assetCode,
            assetPair: asset.assetPair,
            assetPairName: asset.assetPairName,
            currencyId: asset.currencyId,
          });
        } else if (basrcurrency === "ALL") {
          if (
            asset.currencyType === 1 &&
            newFiatArray.includes(asset.baseCurrency) == true
          ) {
            newAssetetpair.push({
              currencycode: asset.currencyCode,
              basecurrency: asset.baseCurrency,
              lastTrade1: asset.ltpValue,
              lastTrade2: asset.ltpConvValue,
              lPriceColor: ltpColor,
              roc: asset.roc,
              volume: asset.volume,
              rocColor: asset.roc > 0,
              amountPrecision: asset.amountPrecision,
              pricePrecision: asset.pricePrecision,
              assetCode: asset.assetCode,
              assetPair: asset.assetPair,
              assetPairName: asset.assetPairName,
              currencyId: asset.currencyId,
            });
          }
        } else if (basrcurrency === "OTHER") {
          if (
            !["AED", "USD", "INR", "ETH", "BTC"].includes(asset.baseCurrency)
          ) {
            let lastprice = `${parseFloat(asset.ltpValue)}/${
              asset.ltpConvValue
            }`;
            newAssetetpair.push({
              currencycode: asset.currencyCode,
              basecurrency: asset.baseCurrency,
              lastTrade1: asset.ltpValue,
              lastTrade2: asset.ltpConvValue,
              lPriceColor: ltpColor,
              roc: asset.roc,
              volume: asset.volume,
              rocColor: asset.roc > 0,
              amountPrecision: asset.amountPrecision,
              pricePrecision: asset.pricePrecision,
              assetCode: asset.assetCode,
              assetPair: asset.assetPair,
              assetPairName: asset.assetPairName,
              currencyId: asset.currencyId,
            });
          }
        }

        setAssetetpairback([...newAssetetpair]);
        setAssetetpairbackOriginal([...newAssetetpair]);

        setRoccolor(isRocPositive);
        setLtpcolor(ltpColor);
      });

      // setAssetetpairbackOriginal(
      //   filteredAssets.map((asset) => ({
      //     currencycode: asset.currencyCode,
      //     basecurrency: asset.baseCurrency,
      //     lastTrade1: asset.ltpValue,
      //     lastTrade2: asset.ltpConvValue,
      //     lPriceColor:
      //       asset.action === "buy"
      //         ? true
      //         : asset.action === "sell"
      //         ? false
      //         : null,
      //     roc: asset.roc,
      //     volume: asset.volume,
      //     rocColor: asset.roc > 0,
      //     amountPrecision: asset.amountPrecision,
      //     pricePrecision: asset.pricePrecision,
      //     assetCode: asset.assetCode,
      //     assetPair: asset.assetPair,
      //     assetPairName: asset.assetPairName,
      //     currencyId: asset.currencyId,
      //   }))
      // );
    } catch (error) {
      console.error("Error fetching asset data", error);
    }
  };

  const handleCurrencySelect = (d) => {
    setSelected(d?.assetPairName);
    setAssetPair(d?.assetPair);
    setCurrencycode(d?.currencycode);
    setBasecurrency(d?.basecurrency);
    localStorage.setItem("O_buying_crypto_asset", d?.currencycode);
    localStorage.setItem("O_selling_crypto_asset", d?.basecurrency);
    setIsOpen(false);
  };

  const handleSearch = (searchText) => {
    if (searchText !== "") {
      const filterData = assetetpairbackOrigin?.filter((data) =>
        data?.currencycode.includes(searchText.toUpperCase())
      );
      setAssetetpairback(filterData);
    } else {
      setAssetetpairback(assetetpairbackOrigin);
    }
  };

  const handleVolumnToggle = () => {
    if (sort) {
      const sortData = assetetpairback.sort((a, b) => a?.volume - b?.volume);
      setAssetetpairback(sortData);
      setSort(false);
    } else {
      const sortData = assetetpairback.sort((a, b) => b?.volume - a?.volume);
      setAssetetpairback(sortData);
      setSort(true);
    }
  };
  const handleSelectFiat = (text) => {
    setFiatSelected(text);
    setShowFiat(false);
  };

  const websocket = {
    stompClient: null,
    unsubscribe: () => console.log("Unsubscribed"),
    _disconnect: () => console.log("WebSocket Disconnected"),
    _connect: () => console.log("WebSocket Connected"),
    subscribe: () => console.log("WebSocket Subscribed"),
  };

  const trade = {
    reload: () => console.log("Trade reloaded"),
    myTradeDisplay: (value) => console.log("My Trade Display: ", value),
  };

  const callTradeHistory = (action) =>
    console.log("Trade History called with action: ", action);

  const setTradeData = (updateFunction) =>
    console.log("Trade Data Updated", updateFunction);

  const buySellCode = (item) => {
    websocket.unsubscribe();

    if (websocket.stompClient !== null) {
      setTimeout(() => {
        websocket.subscribe();
      }, 5000);
    }

    if (websocket?.tickerSubscription) {
      websocket?.tickerSubscription?.unsubscribe();
    }
    if (websocket?.subscription) {
      websocket?.subscription?.unsubscribe();
    }
    if (websocket?.subscription1) {
      websocket?.subscription1?.unsubscribe();
    }

    // resetStopLossInputField();

    setCurrencycode(item.currency === "BCC" ? "BCH" : item.currencycode);
    setBasecurrency(item.basecurrency);
    setAssetPair(item.assetPair);
    setAssetPairName(item.assetPairName);
    setAmountPrecision(item.amountPrecision);
    setPricePrecision(item.pricePrecision);
    setAssetCode(item.assetCode);
    setCurrencyId(item.currencyId);

    // document.getElementById("myDropdown")?.classList.toggle("show");

    localStorage.setItem("amountprc", item.amountPrecision);
    localStorage.setItem("priceprc", item.pricePrecision);
    localStorage.setItem("assetCode", item.assetCode);
    localStorage.setItem("currencyId", item.currencyId);

    // data.selectedSellingAssetText = item.baseCurrency;
    // data.selectedBuyingAssetText = item.currencyCode;
    // data.selectedBuyingCryptoCurrencyName = item.baseCurrency + item.currencyCode;
    // data.selectedSellingCryptoCurrencyName = item.currencyCode + item.baseCurrency;

    localStorage.setItem(
      "derivative_buying_crypto_asset",
      item.currencycode?.toLowerCase()
    );
    localStorage.setItem(
      "derivative_selling_crypto_asset",
      item.basecurrency?.toLowerCase()
    );
    localStorage.setItem("selected_derivative_asset_pair", item.assetPair);
    localStorage.setItem(
      "selected_derivative_asset_pair_name",
      item.assetPairName
    );

    localStorage.setItem("isAssetPairChangedRecentlyFutures", "true");
    localStorage.setItem("isResetTheStoplossfieldForFutures", "true");

    let assetChangeCounter = localStorage.getItem(
      "assetChangeCounterForFutures"
    );
    if (assetChangeCounter) {
      assetChangeCounter = parseInt(assetChangeCounter) + 1;
      localStorage.setItem(
        "assetChangeCounterForFutures",
        assetChangeCounter.toString()
      );
    } else {
      localStorage.setItem("assetChangeCounterForFutures", "1");
    }

    // handleSetLeverageMinMaxValue('2', '125');
  };

  console.log("assetetpairback", assetetpairback);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", flex: 1, minHeight: 0, position: "relative" }}>
      <div
        className="currency_Container"
        style={{
          backgroundColor: pairButtonColor || btncolor,
          flexShrink: 0,
        }}
      >
        <p
          className="currency_text d-flex align-items-center justify-content-center"
          onClick={handleToggle}
        >
          {selected || assetpair}
          {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </p>
      </div>
      {isOpen && (
        <div
          className="dropdown_ derivativeDropdown"
          style={{
            backgroundColor: "var(--body-color)",
          }}
        >
          <div
            className="currency_ d-flex justify-content-between align-items-center"
            style={{ padding: "5px" }}
          >
            <div>
              {header?.length !== 0 &&
                header?.map((d, i) => (
                  <button
                    key={i}
                    onClick={() => getNewCurrency(d)}
                    style={{
                      cursor: "pointer",
                      fontSize: "16px",
                      border: "none",
                      backgroundColor: "var(--body-color-less3)",
                      color: "white",
                      padding: "5px 10px",
                      marginLeft: "10px",
                      borderRadius: "5px",
                      boxShadow:
                        "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
                    }}
                  >
                    {d}
                  </button>
                ))}
            </div>

            <div
              className="search_container"
              tabindex="0"
              style={{ width: "30%" }}
            >
              <i class="fa-solid fa-magnifying-glass"></i>
              <input
                type="text"
                placeholder="Search"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>

          <div
            className="table_content_dropdown"
            style={{ maxHeight: "200px" }}
          >
            <table style={{ marginTop: "7px" }}>
              <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                <th
                  style={{
                    textAlign: "start",
                    backgroundColor: "var(--body-color-less3)",
                    color: "var(--text-color)",
                  }}
                >
                  Pair
                </th>
                <th
                  style={{
                    backgroundColor: "var(--body-color-less3)",
                    color: "var(--text-color)",
                  }}
                >
                  Last Price
                </th>
                <th
                  style={{
                    backgroundColor: "var(--body-color-less3)",
                    color: "var(--text-color)",
                  }}
                >
                  ROC
                </th>
                <th
                  style={{
                    cursor: "pointer",
                    backgroundColor: "var(--body-color-less3)",
                    color: "var(--text-color)",
                  }}
                  onClick={handleVolumnToggle}
                >
                  <ImportExportIcon sx={{ fontSize: "16px" }} /> Volume
                </th>
              </thead>
              <tbody style={{ overflowY: "scroll" }}>
                {assetetpairback?.length !== 0 &&
                  assetetpairback?.map((d, i) => (
                    <tr
                      key={i}
                      onClick={() => buySellCode(d)}
                      style={{ cursor: "pointer" }}
                    >
                      <td
                        style={{
                          fontWeight: "bold",
                          cursor: "pointer",
                          textAlign: "start",
                          color: theme === "dark" ? "white" : "black",
                        }}
                        onClick={() => handleCurrencySelect(d)}
                      >
                        <img
                          src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${d?.currencycode}.png`}
                          alt="vtho"
                          style={{
                            height: "14px",
                            width: "14px",
                            marginRight: "3px",
                          }}
                        />
                        {d?.assetPairName}
                      </td>
                      <td
                        className="text-white asset-dtl-font text-right"
                        style={{ fontSize: "16px" }}
                      >
                        <span
                          style={{
                            color:
                              d?.lpricecolor === null
                                ? theme === "dark"
                                  ? "beige"
                                  : "black"
                                : d?.lpricecolor
                                ? upColor
                                : downColor,
                          }}
                        >
                          {d?.lastTrade1}
                        </span>
                        <span
                          style={{
                            color: "rgb(161, 161, 159)",
                            fontSize: "10px",
                          }}
                        >
                          {" "}
                          /{" "}
                        </span>
                        <span style={{ color: "rgb(161, 161, 159)" }}>
                          {d?.basecurrency === "INR" && "₹"}
                          {["USD", "USDT"].includes(d?.basecurrency) && "$"}
                          {d?.basecurrency === "AED" && "د.إ"}
                        </span>
                        <span style={{ color: "rgb(161, 161, 159)" }}>
                          {d?.lastTrade2}
                        </span>
                      </td>
                      <td
                        style={{
                          color: d?.isRocPositive
                            ? upColor
                            : downColor,
                        }}
                      >
                        {(d?.roc).toFixed(2)}
                      </td>
                      <td
                        style={{ color: theme === "dark" ? "white" : "black" }}
                      >
                        {d?.volume}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <FutureOrderBook />
      </div>
    </div>
  );
};

export default FutureLeftTable;
